export default "__VITE_PUBLIC_ASSET__834efe6d__"